import { useContext, useEffect, useState } from "react";
import {Link, Outlet, useNavigate} from "react-router-dom";
import { I18nContext, useTranslation } from 'react-i18next';
import { Slide, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { useLocation } from 'react-router-dom';

import { LocalStorage } from "../../services";

import LogoImage from '../../assets/images/logos/logo.png';
import SideBarMenuItem from "../../components/Sidebar/SideBarMenuItem/SideBarMenuItem.component";
import SideBarMenuTitle from "../../components/Sidebar/SideBarMenuTitle/SideBarMenuTitle.component";

const AppLayout = () => {
	const { t } = useTranslation();
	const permissions = LocalStorage.get('permissions').split(',');
	const location = useLocation();
	const navigate = useNavigate();
	const i18nContext = useContext(I18nContext);

	const closeSidebarMenu = () => {
		document.querySelector('#navbarVerticalCollapse').classList.remove('show');
	};

	const [darkTheme, setDarkTheme] = useState((LocalStorage.get('theme') && LocalStorage.get('theme') === 'dark') ? true : false);
	useEffect(() => {
		document.querySelector('html').setAttribute('data-bs-theme', darkTheme ? 'dark' : 'light');
		LocalStorage.set('theme', darkTheme ? 'dark' : 'light');
	}, [darkTheme]);

	const [faLanguage, setFaLanguage] = useState((LocalStorage.get('language') && LocalStorage.get('language') === 'fa') ? true : false);
	useEffect(() => {
		document.querySelector('html').setAttribute('dir', faLanguage ? 'rtl' : 'ltr');
		LocalStorage.set('language', faLanguage ? 'fa' : 'en');
		const themeStylesLink = document.getElementById('theme-styles');
		const themeStylesFile = faLanguage ? themeStylesLink.getAttribute('data-fa-url') : themeStylesLink.getAttribute('data-en-url');
		themeStylesLink.href = themeStylesFile;
		i18nContext.i18n.changeLanguage(faLanguage ? 'fa' : 'en');
	}, [faLanguage]);

	const logout = () => {
		LocalStorage.remove('token');
		LocalStorage.remove('permissions');
		LocalStorage.remove('verify-login');
		navigate('/login');
	};

	useEffect(() => {
		closeSidebarMenu();
	}, [location]);

	return (
		<>
			<main className="main" id="top">
				<div className="container" data-layout="container">
					<nav className="navbar navbar-light navbar-vertical navbar-expand-xl">
						<div className="d-flex align-items-center">
							<div className="toggle-icon-wrapper">
								<button className="btn navbar-toggler-humburger-icon navbar-vertical-toggle navbar-toggler" data-bs-target="#navbarVerticalCollapse" data-bs-toggle="tooltip" data-bs-placement="left">
									<span className="navbar-toggle-icon">
										<span className="toggle-line"></span>
									</span>
								</button>
							</div>
							<Link className="navbar-brand" to="/dashboard">
								<div className="d-flex align-items-center py-3">
									{/* <img className="me-2" src={LogoImage} alt="" width="40" /> */}
									<span className="font-sans-serif">{t('project_name')}</span>
								</div>
							</Link>
						</div>
						<div className="collapse navbar-collapse" id="navbarVerticalCollapse">
							<div className="navbar-vertical-content scrollbar">
								<ul className="navbar-nav flex-column mb-8" id="navbarVerticalNav">
									<li className="nav-item">
										<SideBarMenuItem destinationRoute='/dashboard' faIconClasses='fas fa-chart-pie' title={t('dashboard')} />
									</li>
									{permissions.includes('Admin') ?
										<li className="nav-item">
											<SideBarMenuTitle title={t('admins_management')} />
											{permissions.includes('Admin') ?
												<>
													<SideBarMenuItem childItems={[{title: t('create'), link: '/admins-create'},{title: t('list'), link: '/admins-list'}]} listID='admins' faIconClasses='fas fa-user-secret' title={t('admins')} />
													<SideBarMenuItem destinationRoute='/tadbir-contents' faIconClasses='fas fa-lock' title={t('tadbir')} />
												</>
											: ''}
										</li>
									: ''}
									{permissions.includes('Usercategories') || permissions.includes('Users') || permissions.includes('Codes') || permissions.includes('Credits') || permissions.includes('ReferralChanges') ?
										<li className="nav-item">
											<SideBarMenuTitle title={t('users_management')} />
											{permissions.includes('Usercategories') ?
												<SideBarMenuItem childItems={[{title: t('create'), link: '/user-categories-create'},{title: t('list'), link: '/user-categories-list'}]} listID='user-categories' faIconClasses='fas fa-layer-group' title={t('user_categories')} />
											: ''}
											{permissions.includes('Users') ?
												<SideBarMenuItem childItems={[{title: t('create'), link: '/users-create'},{title: t('list'), link: '/users-list'}]} listID='users' faIconClasses='fas fa-users' title={t('users')} />
											: ''}
											{permissions.includes('Credits') ?
												<SideBarMenuItem childItems={[{title: t('create'), link: '/credits-create-by-excel'},{title: t('list'), link: '/credits-list'}]} listID='credits' faIconClasses='fas fa-credit-card' title={t('credits')} />
											: ''}
											{permissions.includes('Codes') ?
												<SideBarMenuItem destinationRoute='/marketing-codes-list' faIconClasses='fas fa-bold' title={t('marketing_codes')} />
											: ''}
											{permissions.includes('ReferralChanges') ?
												<SideBarMenuItem destinationRoute='/referral-changes-list' faIconClasses='fas fa-exchange-alt' title={t('referral_changes')} />
											: ''}
										</li>
									: ''}
									{permissions.includes('Requestcategories') || permissions.includes('Requests') ?
										<li className="nav-item">
											<SideBarMenuTitle title={t('portal_management')} />
											{permissions.includes('Requestcategories') ?
												<SideBarMenuItem childItems={[{title: t('create'), link: '/request-categories-create'},{title: t('list'), link: '/request-categories-list'}]} listID='request_categories' faIconClasses='fas fa-layer-group' title={t('request_categories')} />
											: ''}
											{permissions.includes('Requests') ?
												<SideBarMenuItem destinationRoute='/requests-list' faIconClasses='fas fa-envelope-open-text' title={t('requests')} />
											: ''}
											<SideBarMenuItem destinationRoute='/marketing-contents' faIconClasses='fas fa-list' title={t('marketing_contents')} />
										</li>
									: ''}
									{permissions.includes('Stocks') || permissions.includes('Signals') || permissions.includes('Signalcomments') ?
										<li className="nav-item">
											<SideBarMenuTitle title={t('analysis_management')} />
											{permissions.includes('Stocks') ?
												<SideBarMenuItem destinationRoute='/stocks-list' faIconClasses='fab fa-apple' title={t('stocks')} />
											: ''}
											{permissions.includes('Signals') ?
												<SideBarMenuItem destinationRoute='/signals-list' faIconClasses='fas fa-chart-line' title={t('signals')} />
											: ''}
											{permissions.includes('Signalcomments') ?
												<SideBarMenuItem destinationRoute='/signal-comments-list' faIconClasses='fas fa-comment-dots' title={t('signal_comments')} />
											: ''}
										</li>
									: ''}
									{permissions.includes('Consultants') || permissions.includes('Consultationcategories') || permissions.includes('Consultations') ?
										<li className="nav-item">
											<SideBarMenuTitle title={t('consultations_management')} />
											{permissions.includes('Consultants') ?
												<SideBarMenuItem childItems={[{title: t('create'), link: '/consultants-create'},{title: t('list'), link: '/consultants-list'}]} listID='consultants' faIconClasses='fas fa-user-tie' title={t('consultants')} />
											: ''}
											{permissions.includes('Consultationcategories') ?
												<SideBarMenuItem childItems={[{title: t('create'), link: '/consultation-categories-create'},{title: t('list'), link: '/consultation-categories-list'}]} listID='consultation-categories' faIconClasses='fas fa-layer-group' title={t('consultation_categories')} />
											: ''}
											{permissions.includes('Consultations') ?
												<SideBarMenuItem destinationRoute='/consultations-list' faIconClasses='fas fa-hands-helping' title={t('consultations')} />
											: ''}
										</li>
									: ''}
									{permissions.includes('Productcategories') || permissions.includes('Products') || permissions.includes('Orders') ?
										<li className="nav-item">
											<SideBarMenuTitle title={t('shop_management')} />
											{permissions.includes('Productcategories') ?
												<SideBarMenuItem childItems={[{title: t('create'), link: '/product-categories-create'},{title: t('list'), link: '/product-categories-list'}]} listID='product-categories' faIconClasses='fas fa-layer-group' title={t('product_categories')} />
											: ''}
											{permissions.includes('Products') ?
												<SideBarMenuItem childItems={[{title: t('create'), link: '/products-create'},{title: t('list'), link: '/products-list'}]} listID='products' faIconClasses='fas fa-shopping-cart' title={t('products')} />
											: ''}
											{permissions.includes('Orders') ?
												<SideBarMenuItem destinationRoute='/product-orders-list' faIconClasses='fas fa-shopping-basket' title={t('product_orders')} />
											: ''}
										</li>
									: ''}
									{permissions.includes('Contests') || permissions.includes('Contestenrolls') || permissions.includes('TopCompetitors') ?
										<li className="nav-item">
											<SideBarMenuTitle title={t('contests_management')} />
											{permissions.includes('Contests') ?
												<SideBarMenuItem destinationRoute='/contests-list' faIconClasses='fas fa-flag-checkered' title={t('weekly_contests')} />
											: ''}
											{permissions.includes('Contestenrolls') ?
												<SideBarMenuItem destinationRoute='/contest-forecasts-list' faIconClasses='fas fa-gamepad' title={t('forecasts')} />
											: ''}
											{permissions.includes('TopCompetitors') ?
												<SideBarMenuItem destinationRoute='/contest-bests-list' faIconClasses='fas fa-crown' title={t('the_bests')} />
											: ''}
										</li>
									: ''}
									{permissions.includes('Banners') ?
										<li className="nav-item">
											<SideBarMenuTitle title={t('banners_management')} />
											{permissions.includes('Banners') ?
												<SideBarMenuItem childItems={[{title: t('create'), link: '/banners-create'},{title: t('list'), link: '/banners-list'}]} listID='banners' faIconClasses='fas fa-images' title={t('banners')} />
											: ''}
										</li>
									: ''}
									{permissions.includes('Transactioncategories') || permissions.includes('Transactions') ?
										<li className="nav-item">
											<SideBarMenuTitle title={t('financial_management')} />
											{permissions.includes('Transactioncategories') ?
												<SideBarMenuItem childItems={[{title: t('create'), link: '/transaction-categories-create'},{title: t('list'), link: '/transaction-categories-list'}]} listID='transaction-categories' faIconClasses='fas fa-layer-group' title={t('transaction_categories')} />
											: ''}
											{permissions.includes('Transactions') ?
												<SideBarMenuItem childItems={[{title: t('create'), link: '/transactions-create'},{title: t('list'), link: '/transactions-list'}]} listID='transactions' faIconClasses='fas fa-money-check' title={t('transactions')} />
											: ''}
										</li>
									: ''}
								</ul>
							</div>
						</div>
					</nav>
					<div className="content">
						<nav className="navbar navbar-light navbar-glass navbar-top navbar-expand">
							<button className="btn navbar-toggler-humburger-icon navbar-toggler me-1 me-sm-3" type="button" data-bs-toggle="collapse" data-bs-target="#navbarVerticalCollapse" aria-controls="navbarVerticalCollapse" aria-expanded="false" aria-label="Toggle Navigation">
								<span className="navbar-toggle-icon">
									<span className="toggle-line"></span>
								</span>
							</button>
							<Link className="navbar-brand me-1 me-sm-3" href="../index.html">
								<div className="d-flex align-items-center">
									<img className="me-2" src={LogoImage} alt="" width="40" />
									<span className="font-sans-serif">{t('project_name')}</span>
								</div>
							</Link>
							<ul className="navbar-nav navbar-nav-icons ms-auto flex-row align-items-center">
								<li className="nav-item px-2">
									<div className="theme-control-toggle fa-icon-wait">
										<input className="form-check-input ms-0 theme-control-toggle-input" id="themeControlToggle" type="checkbox" data-theme-control="theme" value="dark" defaultChecked={darkTheme} onChange={e => setDarkTheme(e.target.checked)} />
										<label className="mb-0 theme-control-toggle-label theme-control-toggle-light" htmlFor="themeControlToggle" data-bs-toggle="tooltip" data-bs-placement="left" aria-label="Switch to light theme" data-bs-original-title="Switch to light theme">
											<span className="fas fa-sun fs-0"></span>
										</label>
										<label className="mb-0 theme-control-toggle-label theme-control-toggle-dark" htmlFor="themeControlToggle" data-bs-toggle="tooltip" data-bs-placement="left" aria-label="Switch to dark theme" data-bs-original-title="Switch to dark theme">
											<span className="fas fa-moon fs-0"></span>
										</label>
									</div>
								</li>
								<li className="nav-item px-2">
									<div className="theme-control-toggle fa-icon-wait">
										<input className="form-check-input ms-0 theme-control-toggle-input" id="languageControlToggle" type="checkbox" data-theme-control="theme" value="fa" defaultChecked={faLanguage} onChange={e => setFaLanguage(e.target.checked)} />
										<label className="mb-0 theme-control-toggle-label theme-control-toggle-light" htmlFor="languageControlToggle" data-bs-toggle="tooltip" data-bs-placement="left" aria-label="Switch to En language" data-bs-original-title="Switch to En language">
											<b>En</b>
										</label>
										<label className="mb-0 theme-control-toggle-label theme-control-toggle-dark" htmlFor="languageControlToggle" data-bs-toggle="tooltip" data-bs-placement="left" aria-label="Switch to Fa language" data-bs-original-title="Switch to Fa language">
											<b>Fa</b>
										</label>
									</div>
								</li>
								<li className="nav-item px-2">
									<div className="theme-control-toggle fa-icon-wait">
										<button className="btn" onClick={logout}>
											<label className="mb-0 theme-control-toggle-label">
												<i className="fa fa-power-off"></i>
											</label>
										</button>
									</div>
								</li>
							</ul>
						</nav>
						<Outlet />
						<footer className="footer">
							<div className="row g-0 justify-content-between fs--1 mt-4 mb-3">
								<div className="col-12 col-sm-auto text-center">
									<p className="mb-0 text-600">Thank you for using MRM admin panel 2024 &copy; <Link to="https://t.me/m7r3m" target="_blank">MRM</Link></p>
								</div>
								<div className="col-12 col-sm-auto text-center">
									<p className="mb-0 text-600">v3.0.0</p>
								</div>
							</div>
						</footer>
					</div>
				</div>
			</main>
			<ToastContainer
				position="top-center"
				autoClose={3000}
				hideProgressBar={false}
				newestOnTop
				closeOnClick
				rtl={false}
				pauseOnFocusLoss
				draggable
				pauseOnHover
				theme="colored"
				transition={Slide}
			/>
		</>
	);
};

export default AppLayout;
